import { AuthenticationContainerComponent } from './authentication.container.component';
import { Routes, RouterModule } from '@angular/router';
import {
  SignupRouteComponent,
  VerifyAccountRouteComponent,
  LoginAuthGuard
} from '@arc/arc-shared-frontend';
import { LoginContainerComponent } from './login/login.container.component';
import { ForgotPasswordContainerComponent } from './forgotpassword/forgotpassword.container.component';
import { CodeVerificationContainerComponent } from './codeverification/codeverification.container.component';
import { PasswordresetContainerComponent } from './passwordreset/passwordreset.container.component';
import { ForceResetPasswordContainerComponent } from './forceresetpassword/forceresetpassword.container.component';
const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'jpmorgan',
    component: AuthenticationContainerComponent,
    children: [
      { path: '', component: LoginContainerComponent }],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'login',
    component: AuthenticationContainerComponent,
    children: [{ path: '', component: LoginContainerComponent }],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'loginredirect',
    component: AuthenticationContainerComponent,
    children: [{ path: '', component: LoginContainerComponent }]
  },
  {
    path: 'forgotpassword',
    component: AuthenticationContainerComponent,
    children: [{ path: '', component: ForgotPasswordContainerComponent }]
  },
  {
    path: 'verificationcode',
    component: AuthenticationContainerComponent,
    children: [{ path: '', component: CodeVerificationContainerComponent }]
  },
  {
    path: 'resetpassword',
    component: AuthenticationContainerComponent,
    children: [{ path: '', component: PasswordresetContainerComponent }]
  },
  {
    path: 'newpasswordrequired',
    component: AuthenticationContainerComponent,
    children: [{ path: '', component: ForceResetPasswordContainerComponent }]
  },
  {
    path: 'signup',
    component: AuthenticationContainerComponent,
    children: [{ path: '', component: SignupRouteComponent }],
    canActivate: [LoginAuthGuard]
  },
  {
    path: 'verifyphonenumber',
    component: AuthenticationContainerComponent,
    children: [{ path: '', component: VerifyAccountRouteComponent }]
  }
];

export const AuthenticationRouting = RouterModule.forChild(routes);
